import { connect } from "react-redux"
import ShowFs from "../Components/ShowFS"


const mapStateToProps = state => ({ fs: state.Fs })


export default connect(mapStateToProps, null)(ShowFs)